import { h } from 'preact';
import { useStore } from 'src/hooks';
import UserType from 'src/common/usertype';
import { sidebarNavigationSectionMaintenance, sidebarNavigationSectionLoggedInGoto, sidebarNavigationItemInbox, sidebarNavigationItemProfile, sidebarNavigationRegistrationWizard, sidebarNavigationPromoLink, sidebarNavigationRegisterStudio, sidebarNavigationChangePassword, sidebarNavigationSectionStudioLogon, sidebarNavigationItemsLoggedIn, sidebarNavigationSectionVideoSession } from './data';
import { SidebarNavigationItem, SidebarNavigationSection } from './types';
import { PROMO } from 'src/common/constants';
import LogonRegister from 'src/components/sidebar/logon-register';
import * as styles from './styles.less';

interface SidebarNavigationProps {
    isFrame?: boolean;
}

const SidebarNavigationChathost = ({ isFrame }: SidebarNavigationProps) => {
    const ctx = useStore();
    const isLoggedIn = ctx.user.isLoggedIn.value && ctx.user.userTypeID.value === UserType.CHATHOST;
    const showRegWizard = ctx.user.showRegWizard.value;
    const isStudioMember = ctx.user.isStudioMember.value;
    const phaseEvent = ctx.promo.phaseEvent.value;
    const promoType = ctx.promo.type.value;

    if (phaseEvent === true && promoType) {
        sidebarNavigationPromoLink.path = PROMO[promoType].route;
        sidebarNavigationPromoLink.isNative = null;
    }

    if (isLoggedIn === true) {
        sidebarNavigationItemProfile.path = ctx.user.profileUrl.value || '';
        sidebarNavigationItemInbox.name = `Inbox (${ctx.user.ccMailNewMessagesCount.value || 0})`;
    }

    const sidebarNavigationSectionLoggedInGotoClone = { ...sidebarNavigationSectionLoggedInGoto };

    sidebarNavigationSectionLoggedInGotoClone.items = [
        // prettier ignore
        ...(showRegWizard === true ? [sidebarNavigationRegistrationWizard] : []),
        ...(phaseEvent === true ? [sidebarNavigationPromoLink] : []),
        ...sidebarNavigationSectionLoggedInGoto.items,
    ];

    const sidebarNavigationSectionMaintenanceClone = { ...sidebarNavigationSectionMaintenance };
    sidebarNavigationSectionMaintenanceClone.items = [
        // prettier ignore
        ...sidebarNavigationSectionMaintenance.items,
        ...(isStudioMember === true ? [] : [sidebarNavigationChangePassword]),
    ];

    const sidebarNavigationStudioLogonClone = { ...sidebarNavigationSectionStudioLogon };
    if (isStudioMember === false) {
        sidebarNavigationStudioLogonClone.items = [
            // prettier ignore
            ...sidebarNavigationSectionStudioLogon.items,
            sidebarNavigationRegisterStudio,
        ];
    }

    const sidebarLoggedIn = [
        // prettier ignore
        sidebarNavigationSectionLoggedInGotoClone,
        ...(isStudioMember === true ? [sidebarNavigationStudioLogonClone] : []),
        sidebarNavigationSectionVideoSession,
        sidebarNavigationSectionMaintenanceClone,
        ...sidebarNavigationItemsLoggedIn,
    ];

    if (isLoggedIn === false) {
        return <LogonRegister isFrame={isFrame} />;
    }

    return (
        <nav class={styles.sidebar__nav}>
            {sidebarLoggedIn.map((section: SidebarNavigationSection) => {
                const sectionIDClass = styles[`id__${section.id}`];
                const sectionIconClass = `${styles.section__title} ${styles.section__icon} ${sectionIDClass}`;
                return (
                    <div class={styles.sidebar__section} key={section.id}>
                        <h5 class={sectionIconClass}>{section.category}</h5>
                        <div class={styles.section__links}>
                            {section.items.map((item: SidebarNavigationItem) => {
                                const dataAttributes: { [key: string]: string } = {};
                                if (item.testId) {
                                    dataAttributes['data-testid'] = item.testId;
                                }

                                return (
                                    <a href={item.path} key={item.id} title={item.title ? item.title : item.name} class={`${styles.sidebar__link} ${item.isNew ? styles.sidebar__link_new : ''}`} data-native={isFrame ? true : item.isNative} target={isFrame && item.frameTarget ? item.frameTarget : item.target} {...dataAttributes}>
                                        {item.name}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </nav>
    );
};

export default SidebarNavigationChathost;
